import { useMemo } from 'react';

import { useFeatureFlag } from './useFeatureFlag';

/**
 * A hook with dynamic feature flags that listens for value changes.
 * Can be used at the global context level to access updated feature flag values
 * across the app.
 */
export const useDynamicFeatureFlags = () => {
  const isBrazeLiveActivitiesEnabled = useFeatureFlag('CELS-3466-braze-live-activities-enabled', { listenForChanges: true }); // prettier-ignore
  const isPdpV2QueryEnabled = useFeatureFlag('MNU-7483-short-pdp-v2-query-enabled', { listenForChanges: true }); // prettier-ignore

  // ─── Bag Feature Flags ───────────────────────────────────────────────
  const orderPlaybackConfig = useFeatureFlag('CELS-4127-order-playback-config', { listenForChanges: true }); // prettier-ignore
  const isExpressPaymentsEnabled = useFeatureFlag('permanent-order-stripe-express-checkout-enabled', { listenForChanges: true }); // prettier-ignore
  const isStripePaymentsSdkEnabled = useFeatureFlag('permanent-order-stripe-payment-sdk-enabled', { listenForChanges: true }); // prettier-ignore
  const isOrderPlaybackEnabled = useFeatureFlag('CELS-4127-order-playback-enabled', { listenForChanges: true }); // prettier-ignore

  return useMemo(
    () => ({
      isBrazeLiveActivitiesEnabled,
      isPdpV2QueryEnabled,

      orderPlaybackConfig,
      isExpressPaymentsEnabled,
      isStripePaymentsSdkEnabled,
      isOrderPlaybackEnabled,
    }),
    [
      isBrazeLiveActivitiesEnabled,
      isPdpV2QueryEnabled,

      orderPlaybackConfig,
      isExpressPaymentsEnabled,
      isStripePaymentsSdkEnabled,
      isOrderPlaybackEnabled,
    ],
  );
};
